import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../store";
import { registerAdmin } from "../../../acions/users";
import { useConfirmationModal } from "./useConfirmationModal";

export const useCreateAdmin = (
  setShowSideBar: React.Dispatch<React.SetStateAction<boolean>>,
  reloadData: () => void,
) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const register = useCallback(
    async (values: any) => {
      try {
        const phone = `1${values.phone.replace(/[\s-()]/g, "")}`;

        setIsLoading(true);

        await Promise.resolve(dispatch(registerAdmin({ ...values, phone })));

        setIsLoading(false);
        setShowSideBar(false);
        reloadData();

        return await Promise.resolve();
      } catch (e) {
        return await Promise.reject(e);
      }
    },
    [dispatch, reloadData, setShowSideBar],
  );

  const { openModal } = useConfirmationModal(isLoading, register);

  const onSubmit = useCallback(
    async (values: any) => {
      try {
        await register(values);
      } catch (e: any) {
        setIsLoading(false);

        if (e.status === 409) {
          openModal(values);
          setShowSideBar(false);
        }
      }
    },
    [register, openModal, setShowSideBar],
  );

  return { isLoading, onSubmit };
};
